import { memo } from 'react';
import { css, cx } from '@eti/styles';
import { ReactComponent as ToiletIcon } from '@eti/assets/icons/c_flat-toilet.svg';
import { vars } from '@etg/wings';
import { rowItemSize } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const toiletStyles = css`
  rect {
    fill: ${vars.colors.inputs.border};
  }
`;
const Toilet = () => {
  return /*#__PURE__*/_jsx(ToiletIcon, {
    className: cx(rowItemSize, toiletStyles)
  });
};
export default /*#__PURE__*/memo(Toilet);
//# sourceMappingURL=Toilet.js.map